import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "./lib/sentry";

// Fire-and-forget. Init resolves once the SDK is loaded (or immediately
// no-ops when no DSN is set). We don't await because we don't want
// observability to block the first paint.
void initSentry();

const shouldDisableServiceWorkers =
  typeof window !== "undefined" &&
  (import.meta.env.DEV || window.location.hostname.includes("id-preview--"));

if (shouldDisableServiceWorkers && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        void registration.unregister();
      });
    });
  });
}

createRoot(document.getElementById("root")!).render(<App />);
